export enum BaseAssignmentsSidebarTabsEnum {
  Schedule = 'Schedule',
  Profile = 'Profile',
}
